import Lista from './Lista';

export const DepartamentoLista = Lista;
